import { useNavigate } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { CATEGORIES } from "@/lib/constants";
import { useLang } from "@/context/LanguageContext";

export default function Categories() {
  const navigate = useNavigate();
  const { t, lang, dir } = useLang();
  const Arrow = dir === "rtl" ? ChevronLeft : ChevronRight;

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="max-w-7xl 2xl:max-w-[1600px] mx-auto px-4 sm:px-8 w-full py-5 pb-6 flex-1">
        <h1 className="font-headline text-2xl font-extrabold text-slate-900" data-testid="categories-title">{t("categories_title")}</h1>
        <p className="text-xs text-slate-500 mb-4">{t("categories_hint")}</p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-5" data-testid="categories-grid">
          {CATEGORIES.map((cat, i) => (
            <button
              key={cat.id}
              onClick={() => navigate(`/category/${cat.id}`)}
              data-testid={`category-card-${cat.id}`}
              style={{ animationDelay: `${i * 70}ms` }}
              className={`relative w-full h-[min(30vh,11rem)] sm:h-56 lg:h-[min(60vh,20rem)] rounded-[28px] overflow-hidden block group shadow-md animate-in fade-in slide-in-from-bottom-2 fill-mode-both ${i === CATEGORIES.length - 1 && CATEGORIES.length % 2 ? "col-span-2 sm:col-span-1" : ""}`}
            >
              <img src={cat.banner} alt="" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-[rgba(26,92,58,0.92)] via-[rgba(26,92,58,0.6)] to-[rgba(26,92,58,0.35)]" />
              <div className="relative h-full flex flex-col items-center justify-center gap-2 sm:gap-3 px-3 text-center">
                <span className="w-[72px] h-[72px] sm:w-24 sm:h-24 lg:w-28 lg:h-28 rounded-full overflow-hidden border-[3px] border-white bg-white shrink-0 shadow-md group-hover:scale-105 transition-transform duration-300">
                  <img src={cat.thumb} alt="" className="w-full h-full object-cover" />
                </span>
                <span className="block font-headline text-base sm:text-xl leading-tight font-extrabold text-white drop-shadow" data-testid={`category-card-name-${cat.id}`}>{lang === "en" ? cat.name_en : cat.name_ar}</span>
                <span className="flex items-center gap-1 text-white/85 text-xs" data-testid={`category-card-count-${cat.id}`}>{cat.subcategories.length} {t("branches")} <Arrow className="w-3.5 h-3.5" data-testid={`category-card-arrow-${cat.id}`} /></span>
              </div>
            </button>
          ))}
        </div>
      </main>
    </div>
  );
}
